export enum BillingProfileStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}

export { InvoicePaymentType as PaymentType } from '../../api/dto/invoice-delivery.dto'

/** Which HubSpot sync wrote the profile last: the overnight job or an operator. */
export type SyncSource = 'AUTO' | 'MANUAL'

/** ISO 8601 date format (e.g. `2026-01-15`), the wire format EPS returns. */
export const ISO_DATE_FORMAT = 'YYYY-MM-DD'

/** User-facing date format (US convention) for plan start and last sync. */
export const DISPLAY_DATE_FORMAT = 'MM/DD/YYYY'

/**
 * A billing profile configures the day of the month invoices fall due, not one
 * fixed date. Each invoice's actual date is this day in the month before its
 * billing period, since a period is funded ahead of the coverage it pays for.
 */
export const MIN_DUE_DAY = 1
export const MAX_DUE_DAY = 31

/** True when a number is a whole day of the month, 1 to 31. */
export const isDueDayInRange = (day: number): boolean =>
  Number.isInteger(day) && day >= MIN_DUE_DAY && day <= MAX_DUE_DAY

/** True when a spreadsheet cell holds a whole day of the month, 1 to 31. */
export const isValidDueDay = (value: string): boolean =>
  isDueDayInRange(Number(value.trim()))

/** Renders a due day as an ordinal, e.g. 1 becomes "1st", 22 becomes "22nd". */
export const formatDueDayLabel = (day: number): string => {
  // 11th, 12th and 13th break the last-digit rule.
  const isTeen = day % 100 >= 11 && day % 100 <= 13
  const suffix = isTeen
    ? 'th'
    : ({ 1: 'st', 2: 'nd', 3: 'rd' }[day % 10] ?? 'th')
  return `${day}${suffix}`
}
